import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicFieldDropdown } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ProductTypeEditTemplate({ productTypeEditViewStore }) {
    const {
        contentLoading,
        form,
        categoryStore,
        tagsStore
    } = productTypeEditViewStore;

    return (
        <ApplicationEditLayout store={productTypeEditViewStore}>
            <Content loading={contentLoading} >
             <div className="row">
                <div className='col col-sml-8 col-lrg-7'>
                    <div className="card card--form card--primary card--med">
                        <div className="row">
                            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                            </div>
                            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                <BaasicFieldDropdown field={form.$('itemCategoryId')} store={categoryStore} />
                            </div>
                            <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                <BaasicFieldDropdown field={form.$('defaultItemTypeTags')} store={tagsStore} />
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ProductTypeEditTemplate.propTypes = {
    productTypeEditViewStore: PropTypes.object
};

export default defaultTemplate(ProductTypeEditTemplate);
